/**
 * Border-radius tokens (rem). Yaxle leans on soft, engineered corners; `md`
 * is the default for interactive controls, `xl`/`2xl` for cards and overlays.
 */
export const radii = {
	none: '0',
	sm: '0.25rem',
	md: '0.5rem',
	lg: '0.625rem',
	xl: '0.875rem',
	'2xl': '1.125rem',
	'3xl': '1.5rem',
	full: '9999px',
} as const;

export default radii;
